import { withSentry } from './modules/sentry';
import $ from 'jquery';

import Vue from 'vue';
import vueCustomElement from 'vue-custom-element';

import {
  globalEventBusPlugin,
  globalStorePlugin
} from '@pixelcabin/ui-utils/lib/vue';

import DynamicCollectionTabs from './components/DynamicTabs/DynamicCollectionTabs.vue';
import DynamicArticleTabs from './components/DynamicTabs/DynamicArticleTabs.vue';
import {
  dynamicArticlesTabsPreprocess,
  dynamicCollectionTabsPreprocess
} from './components/DynamicTabs/preprocess_props';
import FlyoutCart from './components/FlyoutCart/FlyoutCart.vue';
import FlyoutCartToggle from './components/FlyoutCart/FlyoutCartToggle.vue';

import { flyoutCart, flyoutCartStore } from './components/FlyoutCart/store';
import { navigationState } from './modules/navigation';
import pageCarousel from './modules/carousel';

$(function () {
  withSentry(() => {
    console.log('initializing scripts after sentry');

    pageCarousel();

    Vue.use(vueCustomElement);
    Vue.use(globalEventBusPlugin);
    Vue.use(globalStorePlugin, [[flyoutCart, flyoutCartStore]]);

    Vue.customElement(
      'pxl-dynamic-collection-tabs',
      DynamicCollectionTabs,
      dynamicCollectionTabsPreprocess
    );

    Vue.customElement(
      'pxl-dynamic-article-tabs',
      DynamicArticleTabs,
      dynamicArticlesTabsPreprocess
    );

    Vue.customElement('pxl-flyout-cart', FlyoutCart);
    Vue.customElement('pxl-flyout-cart-toggle', FlyoutCartToggle);
    navigationState();
  });
});
